// extracted by mini-css-extract-plugin
export default {"footer":"ui_footer__lqOC7"};